module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAEaSURBVHja7N1RDoUgDARA7n9pvMR7brcOyf5XJjEpoJx775FcTAIAAAIAgAAAIAAACAAAUgawcVQAbB+jAb4yAGxHMPlhBABhBABhBABhhH8ATG9+RiEACCMACCMACCMACCMACCMACCMACCMAAAAAAAAAAAAAAAAAgA0ZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPX11QKsrLMFoOl75lUAjf+yANBU8+SHaTuOsgrgANgHcAAAAAAgN/kAAHgFAQAAAIBGzFIEAItxlqMBvIQAIARRUWfbpvymGlccS5lck3NBAAAAAADABQ6TexYApQAQftSxu8YqvFTiMjU36QEQAAAEAAABAEAAABAA38kDAAD//wMAixknmmyQ6K4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/save-icon.png
// module id = 20
// module chunks = 0